<!-- <button class="close-button" mat-icon-button mat-dialog-close>X</button>
<div mat-dialog-title>
    <mat-icon style="margin-right: 16px;">error_outline</mat-icon>
    <span style="font-weight: normal; font-size:16px;margin-left:-10px !important;">{{viewModel?.title}}</span>
</div>
<mat-dialog-content>
    <span style="font-weight: normal; font-size:12px">{{viewModel?.message}}</span>
    <mat-expansion-panel [expanded]="false" *ngIf="viewModel.errorDetails" style="margin-top: 10px;">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <span style="font-weight: 500;">Details:</span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <pre style="font-weight: normal; font-size:10pt">{{viewModel?.errorDetails}}</pre>
        </ng-template>
    </mat-expansion-panel>
</mat-dialog-content> -->
<!-- <button class="close-button" mat-icon-button mat-dialog-close>X</button> -->

<!-- <button mat-icon-button mat-dialog-close class="close-button">
  <mat-icon>close</mat-icon>
</button> -->
<div mat-dialog-title class="dialog-title">
  <mat-icon class="dialog-icon">error_outline</mat-icon>
  <span class="dialog-title-text">{{ viewModel?.title }}</span>
</div>

<mat-dialog-content>
  <span class="dialog-message">{{ viewModel?.message }}</span>

  <mat-expansion-panel *ngIf="viewModel?.errorDetails" class="details-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="details-title">Details:</span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
      <pre class="details-text">{{ viewModel?.errorDetails }}</pre>
    </ng-template>
  </mat-expansion-panel>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="ok-button" [mat-dialog-close]="true">Ok</button>
</mat-dialog-actions>
